import { Component } from '@angular/core';

@Component({
  selector: 'cl-ui-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
})
export class MainContentComponent {}
